import axios from 'axios';

// Auto-detect API port in development
const detectApiPort = () => {
  const ports = [3001, 3002, 3003, 3004, 3005];
  return ports[0]; // Default to 3001, will handle errors gracefully
};

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : `http://localhost:${detectApiPort()}/api`;

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const paperAPI = {
  getAllPapers: (limit = 20, offset = 0, searchQuery = '', tags = []) => {
    let url = `/papers?limit=${limit}&offset=${offset}`;
    if (searchQuery) url += `&q=${encodeURIComponent(searchQuery)}`;
    if (tags.length > 0) url += `&tags=${tags.join(',')}`;
    return api.get(url);
  },
  
  getPaperById: (id) => 
    api.get(`/papers/${id}`),
  
  addToFavorites: (paperId, userId = 'default') => 
    api.post(`/papers/${paperId}/favorite`, { userId }),
  
  removeFromFavorites: (paperId, userId = 'default') => 
    api.delete(`/papers/${paperId}/favorite`, { data: { userId } }),
  
  getFavorites: (userId = 'default') => 
    api.get(`/papers/favorites/${userId}`),
  
  fetchNewPapers: () => 
    api.post('/papers/fetch'),
  
  getSearchSuggestions: (query) =>
    api.get(`/papers/search/suggestions?q=${encodeURIComponent(query)}`),
  
  getSearchInsights: () =>
    api.get('/papers/search/insights')
};

export const patternAPI = {
  getAllPatterns: () =>
    api.get('/patterns'),
  
  getPatternCategories: () =>
    api.get('/patterns/categories'),
  
  searchPatterns: (query, category) => {
    let url = '/patterns/search';
    const params = [];
    if (query) params.push(`q=${encodeURIComponent(query)}`);
    if (category) params.push(`category=${encodeURIComponent(category)}`);
    if (params.length > 0) url += `?${params.join('&')}`;
    return api.get(url);
  },
  
  getPatternStats: () =>
    api.get('/patterns/stats'),
  
  getPatternDetails: (patternId) =>
    api.get(`/patterns/${patternId}`),
  
  extractPatternsFromPaper: (paperId) =>
    api.get(`/patterns/extract/${paperId}`),
  
  getTrendingPatterns: () =>
    api.get('/patterns/trending/now')
};

export default api;